// extracted by mini-css-extract-plugin
export default {"content":"fL-z","lookName":"gL-z","shopTheLookContainer":"hL-z","productContainer":"iL-z","imageContainer":"jL-z","mainImage":"kL-z"};